
import Api from '@/utils/api';
import {
addCart
} from '../../api';
import querystring from 'vux/src/tools/querystring/index.js'

export default {
data() {
return {
isBallArr: [{
show: false
}]
}
},
methods: {
beforeDrop(el) {
console.log('beforeDrop', el)
let x = this.classifyAnimate.x;
let y = this.classifyAnimate.y;
let w = document.documentElement.clientWidth;
let h = document.documentElement.clientHeight;
let box_h = parseInt(document.documentElement.style.fontSize) * 1.8;
let l = w - y - (parseInt(document.documentElement.style.fontSize) * 0.3) - ((w / 4 / 2 + w / 4) + box_h / 2);
el.style.background = `url(${this.classifyAnimate.headPic}) no-repeat center`;
el.style.backgroundSize = `cover`;
el.style.right = w / 4 + w / 4 / 2 - box_h / 2 + 'px';


console.log({x, y, w, h, box_h, l, t: h-box_h-y, r: w / 4 + w / 4 / 2 - box_h / 2});
el.style.transform = `  translate3d(-1.32rem,-${h-box_h-y}px,0) `;
},
dropping(el) {
console.log('dropping', el)
let rf = el.offsetHeight;
this.$nextTick(() => {
let x = this.classifyAnimate.x;
let y = this.classifyAnimate.y;
let w = document.documentElement.clientWidth;
let h = document.documentElement.clientHeight;
let box_h = parseInt(document.documentElement.style.fontSize) * 1.8;
console.log(box_h)
el.style.transform = `translate3d(0,0,0) `;
});
},
afterDrop(el) {
el.style.display = "none";
this.isBallArr.push({
show: false
});

let data = querystring.stringify({
item_id: this.classifyAnimate.item_id,
sku_id: this.classifyAnimate.sku_id, //商品idcreateOrder
quantity: "1", //数量
mode: "cart" 
});
Api.addProductToCart({
product: this.classifyAnimate.item_id
})
.then(res => {
if (res.data.error) {
console.error(res)
return
}
Api.getCartCount()
})







},
},
mounted() {
for (let i = 0; i < 20; i++) {
this.isBallArr.push({
show: false
});
};
},
computed: {
classifyAnimate() {
return this.$store.state.classifyAnimate;
}
},
watch: {
classifyAnimate(val) {
console.log('animate', this.isBallArr);
for (let i = 0; i < this.isBallArr.length; i++) {
if (!this.isBallArr[i].show) {
this.isBallArr[i].show = true;
break;
}
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Classify/AnimateAddShop.vue